import axiosInstance from "./AxiosInstance";

export function createLabelZebra(data) {
  return axiosInstance.post(`/label-zebra`, data);
}
export function createLabelBrother(data) {
  return axiosInstance.post(`/label-brother`, data);
}

export function createIELSLabelZebra(data) {
  return axiosInstance.post(`/iels-zebra-label`, data);
}
export function createIELSLabelBrother(data) {
  return axiosInstance.post(`/iels-brothers-label`, data);
}

export function getLabelList(data) {
  return axiosInstance.post(`/label/list`, data);
}

export function createLabelZebras(data) {
  return axiosInstance.post(`/label-zebra`, data);
}

export function createLabelBrothers(data) {
  return axiosInstance.post(`/label-brother`, data);
}

export function CreateRePrint(data) {
  return axiosInstance.post(`/label-re-print`, data);
}

// Template-based label printing (2026-04). The API builds the full payload
// (including computed fields) and dispatches via Socket.IO to the printer.
export function printPartLabel(data) {
  return axiosInstance.post(`/part/print-label`, data);
}
export function printVehicleLabel(data) {
  return axiosInstance.post(`/vehicle/print-label`, data);
}
export function getPartActiveUnits(data) {
  return axiosInstance.post(`/part/active-units`, data);
}
export function labelHistoryUser(data) {
  return axiosInstance.post(`/label/history-user`, data);
}
export function labelReprintQueue(data) {
  return axiosInstance.post(`/label/reprint-queue`, data);
}

// Print templates management (2026-04)
export function listPrintTemplates() {
  return axiosInstance.post(`/templates/list`, {});
}
export function setDefaultPrintTemplate(data) {
  return axiosInstance.post(`/templates/set-default`, data);
}
export function getPrintTemplate(data) {
  return axiosInstance.post(`/templates/get`, data);
}
export function createPrintTemplate(data) {
  return axiosInstance.post(`/templates/create`, data);
}
export function updatePrintTemplate(data) {
  return axiosInstance.post(`/templates/update`, data);
}
export function deletePrintTemplate(data) {
  return axiosInstance.post(`/templates/delete`, data);
}
export function duplicatePrintTemplate(data) {
  return axiosInstance.post(`/templates/duplicate`, data);
}
export function availableTemplateFields(data) {
  return axiosInstance.post(`/templates/available-fields`, data);
}
export function uploadCompanyPrintLogo(formData) {
  return axiosInstance.post(`/company/print-logo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
export function deleteCompanyPrintLogo() {
  return axiosInstance.post(`/company/print-logo-delete`, {});
}
